<button type="button" class="exercise-item" [ngClass]="exercise.description ? 'with-sub' : 'without-sub'" [ngStyle]="{'background-image': 'url(' + thumbpath() + ')'}" *ngIf="exercise.isstringvideo && video.id && exercise.thumb && exercise.infozone_id == null" (click)="select()">
  <h3 class="ex-title" [innerHTML]="displayText(exercise.title)">
  
  </h3>
  <div *ngIf="exercise.description" class="ex-subtitle" [innerHTML]="displayText(exercise.description)">
  
  </div>
  <ion-icon class="diary-icon" name="chevron-forward-outline" slot="end"></ion-icon>

</button>
<button type="button" class="exercise-item" [ngClass]="exercise.description ? 'with-sub' : 'without-sub'"  [ngStyle]="{'background-image': 'url(' + thumbpath() + ')'}"  *ngIf="!exercise.isstringvideo && exercise.infozone_id == null" (click)="selectvideo()">
  <h3 class="ex-title" [innerHTML]="displayText(exercise.title)">
  
  </h3>
  <div *ngIf="exercise.description" class="ex-subtitle" [innerHTML]="displayText(exercise.description)">
  
  </div>
  <ion-icon class="diary-icon" name="chevron-forward-outline" slot="end"></ion-icon>
</button>

<button type="button" class="exercise-item" [ngClass]="exercise.description ? 'with-sub' : 'without-sub'"  [ngStyle]="{'background-image': 'url(' + thumbpath() + ')'}"  *ngIf="exercise.infozone_id != null" (click)="selectinfozone()">
  <h3 class="ex-title" [innerHTML]="displayText(exercise.title)">
  
  </h3>
  <div *ngIf="exercise.description" class="ex-subtitle" [innerHTML]="displayText(exercise.description)">
  
  </div>
  <ion-icon class="diary-icon" name="chevron-forward-outline" slot="end"></ion-icon>
</button>

